/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array, func, object, string,
} from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Helper
import { format } from 'date-fns';

const styles = (theme) => ({
    root: {
        textAlign: 'center',
        justifyContent: 'center',
    },
    rootToLeft: {
        justifyContent: 'flex-start',
    },
    monthWrapper: {
        display: 'inline-block',
    },
    monthBtn: {
        backgroundColor: '#fff',
        margin: '0 6px 12px',
        width: '84px',
        height: '72px',
        border: '1px solid #E9E9E9',
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '500',
        textTransform: 'capitalize',
        padding: '6px 10px',
        '&>span': {
            fontSize: '14px',
            [theme.breakpoints.down(500)]: {
                fontSize: '12px',
                lineHeight: '1.1em',
            },
        },
        '&:hover, &:visited, &:active, &:focus': {
            backgroundColor: '#DEEFE6 !important',
            border: '1px solid #044422',
        },
        [theme.breakpoints.down(626)]: {
            margin: '0 3px 6px',
        },
        [theme.breakpoints.down(500)]: {
            width: '78px',
            height: '60px',
            padding: '4px',
        },
    },
    selectedMonthBtn: {
        backgroundColor: '#DEEFE6 !important',
        border: '1px solid #044422',
        fontWeight: 'bold',
    },
});

const MonthDatedCalendarView = ({
    classes,
    isMonthActive,
    monthDatedData,
    getSelectedMonthDetails,
    selectedDeliveryDate,
}) => {
    const showMonthCalendar = () => monthDatedData.map((data) => {
        const {
            day, year, month, calendarDateType, deliverySLA,
        } = data;
        const fullDate = new Date(year, month, day);
        const newMonth = (`0${(fullDate.getMonth() + 1)}`).slice(-2);
        const newDay = (`0${fullDate.getDate()}`).slice(-2);
        const newYear = fullDate.getFullYear();
        const monthCurrentDate = [newYear, newMonth, newDay].join('-');
        const monthlyName = format(fullDate, 'MMM');
        // Check delivery date or range start date match with the month
        let isSelectedMonth = isMonthActive === monthCurrentDate;
        if (!isSelectedMonth && selectedDeliveryDate?.rangeStartDate) {
            isSelectedMonth = monthCurrentDate === format(new Date(selectedDeliveryDate.rangeStartDate), 'yyyy-MM-dd');
        }

        return (
            <div id="month-calendar-view" className={classes.monthWrapper}>
                <Button
                    key={`list-${month}`}
                    className={isSelectedMonth ? `${classes.monthBtn} ${classes.selectedMonthBtn}` : classes.monthBtn}
                    onClick={() => getSelectedMonthDetails(monthCurrentDate, calendarDateType, deliverySLA)}
                > {monthlyName}<br />{year}
                </Button>
            </div>
        );
    });

    return (
        <Grid container className={`${classes.root} ${monthDatedData?.length < 6 ? classes.rootToLeft : ''}`}>
            {showMonthCalendar()}
        </Grid>
    );
};

MonthDatedCalendarView.propTypes = {
    classes: object.isRequired,
    isMonthActive: string.isRequired,
    getSelectedMonthDetails: func.isRequired,
    monthDatedData: array.isRequired,
    selectedDeliveryDate: object.isRequired,
};

export default withStyles(styles)(MonthDatedCalendarView);
